import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import { Button, TextField } from "@mui/material";
import { API } from "../assets/staticData";
import RedirectsDataTable from "../components/data-tables/RedirectsDataTable";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function Redirects({ user }) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState({ source: "", destination: "/", type: 301 });
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0
    }
  })

  async function getData(page = 0) {
    try {
      setLoading(true)

      const res = await fetch(`${API}/redirects?sort=createdAt:desc&pagination[pageSize]=10&pagination[page]=${page}`, {
        headers,
        method: "GET",
      })

      const respone = await res.json();

      setPlatforms(respone.data)
      setMeta(respone.meta)
      setLoading(false)

    } catch (error) {
      console.log(error)
      setLoading(false)

    }
  }

  useEffect(() => {
    // async function getData() {
    //   fetch(`${API}/redirects`, {
    //     headers,
    //     method: "GET",
    //   }).then(async (res) => {
    //     const respone = await res.json();
    //     setPlatforms(respone.data);
    //   });
    // }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }



  const addItem = () => {
    fetch(`${API}/redirects`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        data: {
          source: data.source,
          destination: data.destination,
          type: data.type,
        },
      }),
    }).then((res) => {
      if (res.ok) {
        setOpenAdd(false);
        setData({ source: "", destination: "/", type: 301 });
        setRefresh(!refresh);
        toast("The Item was successfully added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    });
  };

  const onFetchRedirects = async ({ page, pageSize }) => {
    await getData(page)
  }

  return (
    <div className="App">
      <ClearCacheButton keys={[CACHE_KEY.redirects]} />
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>
          Redirects Settings
        </h3>

        {user.perms[26].add && (
          <div
            className="addC"
            style={{ minHeight: openAdd ? 300 : 50, padding: openAdd ? 20 : 0 }}
          >
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <TextField
                  label="Source URL"
                  sx={{ width: "50%", mb: 2 }}
                  value={data.source}
                  onChange={(e) => {
                    setData({ ...data, source: e.target.value });
                  }}
                />
                <TextField
                  label="Destination"
                  sx={{ width: "50%" }}
                  value={data.destination}
                  onChange={(e) => {
                    setData({ ...data, destination: e.target.value });
                  }}
                />

                <div className="mt-4 gap-3 flex">
                  <Button
                    variant="contained"
                    disableElevation
                    style={{
                      background: data.type == 301 ? null : "#99cfe0",
                    }}
                    onClick={() => setData({ ...data, type: 301 })}
                  >
                    301 Permanent Move
                  </Button>
                  <Button
                    variant="contained"
                    disableElevation
                    style={{ background: data.type == 302 ? null : "#99cfe0" }}
                    onClick={() => setData({ ...data, type: 302 })}
                  >
                    302 Temporary Move
                  </Button>
                  <Button
                    variant="contained"
                    disableElevation
                    style={{ background: data.type == 307 ? null : "#99cfe0" }}
                    onClick={() => setData({ ...data, type: 307 })}
                  >
                    307 Temporary Redirect
                  </Button>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? addItem() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}
            >
              Add a new Redirect
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setData({ source: "", destination: "/", type: 301 });
                }}
                className="cancelBTN"
              >
                Cancel
              </div>
            )}
          </div>
        )}

        <RedirectsDataTable
          data={platforms}
          refresh={refresh}
          loading={loading}
          meta={meta}
          user={user}
          setRefresh={setRefresh}
          onChangeQuery={onFetchRedirects}
        />
      </div>
    </div>
  );
}
